/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import Vue from 'vue';
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import VueSelect from 'vue-select';
import VueSweetalert2 from 'vue-sweetalert2';
import '@mdi/font/css/materialdesignicons.css'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import '@trevoreyre/autocomplete-vue/dist/style.css';
import moment from "moment";
import 'animate.css';
import {
    createPinia,
    PiniaVuePlugin
} from 'pinia';

const sweetAlertConfig = {
    customClass: {
        popup: 'sweet-alert-popup-custom-class',
        title: 'sweet-alert-title-custom-class',
        text: 'sweet-alert-body-custom-class',
        confirmButton: 'sweet-alert-confirm-button-custom-class',
        cancelButton: 'sweet-alert-cancel-button-custom-class',
    },
    confirmButtonColor: '#49BEB3',
    cancelButtonColor: 'transparent',
}


var EventBus = new Vue()
window.EventBus = EventBus;

window.Vue = require('vue');
Vue.use(Vuetify);
Vue.use(VueSelect);
Vue.use(VueSweetalert2, sweetAlertConfig);
Vue.use(Autocomplete);
Vue.use(VueBootstrapTypeahead);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
require('moment/locale/es')
Vue.use(require('vue-moment'), {
    moment
});

const opts = {
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#49BEB3',
                medium: '#F8F9FA',
                grey: '#868E98'
            },
        },
    },
};
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
var EventBus = new Vue()
window.EventBus = EventBus;

window.Swal = require('sweetalert2')
Swal=Swal.mixin(sweetAlertConfig)

//Vue.component('schedule', require('./components/schedule/Schedule.vue').default);

//Vue.component('profile-patient', require('./components/patient/ProfilePatient.vue').default);
//Vue.component('edit-patient', require('./components/patient/EditPatient.vue').default);
/* Vue.component('create-payment', require('./components/payments/CreatePayment.vue').default);
Vue.component('create-budget', require('./components/budgets/CreateBudget.vue').default);
Vue.component('details-budget', require('./components/budgets/ShowBudgetDetails.vue').default);
Vue.component('search-component', require('./components/search/SearchComponent.vue').default); */

//labs components
/* Vue.component('create-lab', require('./components/lab/CreateLab.vue').default);
Vue.component('edit-lab', require('./components/lab/EditLab.vue').default); */

//Treatment components
/* Vue.component('create-treatment', require('./components/treatment/CreateTreatment.vue').default);
Vue.component('create-category', require('./components/treatment/CreateCategory.vue').default);
Vue.component('edit-treatment', require('./components/treatment/EditTreatment.vue').default);
Vue.component('edit-category', require('./components/treatment/EditCategory.vue').default); */
//reports
/* Vue.component('daily-cash-report', require('./components/reports/DailyCashReport.vue').default);
Vue.component('daily-generic-report', require('./components/reports/DailyGenericReport.vue').default);
Vue.component('patients-debtor', require('./components/reports/PatientDebtor.vue').default);
Vue.component('all-payments-details', require('./components/reports/AllDailyPayments.vue').default);
 */
//user Components
/* Vue.component('create-user', require('./components/user/CreateUser.vue').default);
Vue.component('edit-user', require('./components/user/EditUser.vue').default);
Vue.component('delete-user', require('./components/user/DeleteUser.vue').default); */
//medical-care
/* Vue.component('medical-care', require('./components/medical-care/Care.vue').default); */

//clinical-record
/* Vue.component('clinical-record', require('./components/clinical-record/ClinicalRecord.vue').default); */


/* Vue.component('search-global-patient', require('./components/globals/SearchPatientAutocomplete.vue').default); */

//globals

/*
Vue.component('form-create-patient', require('./components/globals/FormPatient.vue').default);
Vue.component('form-create-payment-global', require('./components/clinical-record/payments/components/CreatePayment.vue').default);
Vue.component('form-create-lab-global', require('./components/clinical-record/labs/components/CreateLabModal.vue').default);
 */
Vue.component('spinner-loader-global-component', require('./components/globals/SpinnerLoaderGlobal.vue').default);
Vue.component('snackbar-global-component', require('./components/globals/SnackBarGlobal.vue').default);
Vue.component('confirm-dialog-global', require('./components/globals/ConfirmGlobal.vue').default);
Vue.component('wrapper-config-app',require('./WrapperGlobalConfig.vue').default);

//admin

//Vue.component('admin-professionals-profile',require('./components/admin/professionals/ProfileProfessional.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    vuetify: new Vuetify(opts),
    el: '#app',
    pinia,
    components: {
        'admin-professionals-profile': () => import(
            /* webpackChunkName: "js/admin-professionals-profile" */
            './components/admin/professionals/ProfileProfessional.vue'
        ),
        'schedule': () => import(
             /* webpackChunkName: "js/schedule" */
             './components/schedule/Schedule.vue'
        ),
        'profile-patient': () => import(
            /* webpackChunkName: "js/profile-patient" */
            './components/patient/ProfilePatient.vue'
        ),
        'edit-patient': () => import(
            /* webpackChunkName: "js/edit-patient" */
            './components/patient/EditPatient.vue'
        ),
        'create-payment': () => import(
            /* webpackChunkName: "js/create-payment" */
            './components/payments/CreatePayment.vue'
        ),
        'create-budget': () => import(
            /* webpackChunkName: "js/create-budget" */
            './components/budgets/CreateBudget.vue'
        ),
        'details-budget': () => import(
            /* webpackChunkName: "js/details-budget" */
            './components/budgets/ShowBudgetDetails.vue'
        ),
        'search-component': () => import(
            /* webpackChunkName: "js/search-component" */
            './components/search/SearchComponent.vue'
        ),
        'create-lab': () => import(
            /* webpackChunkName: "js/create-lab" */
            './components/lab/CreateLab.vue'
        ),
        'edit-lab': () => import(
            /* webpackChunkName: "js/edit-lab" */
            './components/lab/EditLab.vue'
        ),
        'create-treatment': () => import(
            /* webpackChunkName: "js/create-treatment" */
            './components/treatment/CreateTreatment.vue'
        ),
        'create-category': () => import(
            /* webpackChunkName: "js/create-category" */
            './components/treatment/CreateCategory.vue'
        ),
        'edit-treatment': () => import(
            /* webpackChunkName: "js/edit-treatment" */
            './components/treatment/EditTreatment.vue'
        ),
        'edit-category': () => import(
            /* webpackChunkName: "js/edit-category" */
            './components/treatment/EditCategory.vue'
        ),
        'daily-cash-report': () => import(
            /* webpackChunkName: "js/daily-cash-report" */
            './components/reports/DailyCashReport.vue'
        ),
        'daily-generic-report': () => import(
            /* webpackChunkName: "js/daily-generic-report" */
            './components/reports/DailyGenericReport.vue'
        ),
        'patients-debtor': () => import(
            /* webpackChunkName: "js/patients-debtor" */
            './components/reports/PatientDebtor.vue'
        ),
        'all-payments-details': () => import(
            /* webpackChunkName: "js/all-payments-details" */
            './components/reports/AllDailyPayments.vue'
        ),
        'create-user': () => import(
            /* webpackChunkName: "js/create-user" */
            './components/user/CreateUser.vue'
        ),
        'edit-user': () => import(
            /* webpackChunkName: "js/edit-user" */
            './components/user/EditUser.vue'
        ),
        'delete-user': () => import(
            /* webpackChunkName: "js/delete-user" */
            './components/user/DeleteUser.vue'
        ),
        'medical-care': () => import(
            /* webpackChunkName: "js/medical-care" */
            './components/medical-care/Care.vue'
        ),
        'clinical-record': () => import(
            /* webpackChunkName: "js/clinical-record" */
            './components/clinical-record/ClinicalRecord.vue'
        ),
        'search-global-patient': () => import(
            /* webpackChunkName: "js/search-global-patient" */
            './components/globals/SearchPatientAutocomplete.vue'
        ),
        'form-create-patient': () => import(
            /* webpackChunkName: "js/form-create-patient" */
            './components/globals/FormPatient.vue'
        ),
        'form-create-payment-global': () => import(
            /* webpackChunkName: "js/form-create-payment-global" */
            './components/clinical-record/payments/components/CreatePayment.vue'
        ),
        'form-create-lab-global': () => import(
            /* webpackChunkName: "js/form-create-lab-global" */
            './components/clinical-record/labs/components/CreateLabModal.vue'
        ),
    }
});


